import {
  IonSelect,
  IonSelectOption,
  IonSegment,
  IonSegmentButton,
  IonList,
  IonLabel,
  IonButton,
  IonInput,
  IonItem,
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonDatetime,
  useIonViewDidEnter,
  IonPopover,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Preferences } from "@capacitor/preferences";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { mk_ion_header } from "../functions/mk_ion_header";
import { send_data } from "../functions/send_data";

export default function TagIst() {
  const { appToken, appServer, appBewohnerId, appBewohnerIdChange, appBewohnerIndex, appBewohnerIndexChange } = useContext(DataContext);
  const { bewohnerid, bewohnerbezeichnung, datum, mahlzeit } = useParams<any>();
  const [zeit, setZeit] = useState<any>(mahlzeit);
  const [NextBewohnerLink, setNextBewohnerLink] = useState<any>();
  const [PrevBewohnerLink, setPrevBewohnerLink] = useState<any>();
  const [NextBewohnerId, setNextBewohnerId] = useState<any>();
  const [PrevBewohnerId, setPrevBewohnerId] = useState<any>();
  const [gewicht, setGewicht] = useState<any>(90);
  const [groesse, setGroesse] = useState<any>(165);
  const [bmi, setBMI] = useState<any>(0);
  const [bmifarbe, setBMIFarbe] = useState<any>("warning");
  const [komponenten, setKomponenten] = useState<any>([]);
  const [gewaehlt, setGewaehlt] = useState<any>();
  const [datumPicker, setDatumPicker] = useState<any>(datum);
  const [datumPickerNext, setDatumPickerNext] = useState<any>();
  const [datumPickerPrev, setDatumPickerPrev] = useState<any>();
  const [bewindex, setBewindex] = useState<any>(appBewohnerIndex);
  const [BewohnerWahlReturn, setBewohnerWahlReturn] = useState<any>(
    <IonRow>
      <IonItem>Lade</IonItem>
    </IonRow>
  );
  // const [auswahl, setAuswahl] = useState<any>(json)
  const [auswahl, setAuswahl] = useState<any>([]);
  const [speiseplanreturn, setSpeiseplanreturn] = useState<any>();

  const checkAuswahl = async () => {
    let essen = "frueh";
    if (zeit === "1") {
      essen = "frueh";
    } else if (zeit === "2") {
      essen = "mittag";
    } else {
      essen = "abend";
    }
    const { value }:any = await Preferences.get({ key: "senioren." + essen });
    setAuswahl(JSON.parse(value));
  };

  const checkGewaehlt = async () => {
    const getDataAuswahl = () => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
      myHeaders.append("Authorization", "Bearer " + appToken);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
      };
      fetch(appServer + "/funktionen/api2/senioren/auswahl.php?bewhohner_id=" + bewohnerid, requestOptions)
        .then((response) => response.json())
        .then(async (result) => {
          setAuswahl(JSON.stringify(result));

          let storagedata = {
            key: "senioren.auswahl",
            value: JSON.stringify(result),
          };
          await Preferences.set(storagedata);
        });
    };
    getDataAuswahl();
    const { value }: any = await Preferences.get({ key: "senioren.auswahl" });
    setGewaehlt(JSON.parse(value));
  };

  function speiseplan() {
    if (Array.isArray(auswahl)) {
      return auswahl.map((elementInArray, index) => {
        if (elementInArray.speiseplan_tag == datumPicker && zeit === "2") {
          return artikel(elementInArray);
        } else if (zeit === "1") {
          return artikel(elementInArray);
        } else if (zeit === "3") {
          return artikel(elementInArray);
        }
      });
    }
  }

  function artikel(elementInArray: any) {
    let color = "";
    if (komponenten[elementInArray.speiseplan_rezepte_id] > 0) {
      color = "success";
    }

    return (
      <IonItem color={color}>
        <IonLabel>
          {komponenten[elementInArray.speiseplan_rezepte_id]} {elementInArray.rezepte_bezeichnung}
        </IonLabel>
        <IonItem>
          <IonSelect
            onIonChange={(e) => {
              if( e.currentTarget !== null ) addKomponente(elementInArray.rezepte_id, e.currentTarget );
            }}
            value={komponenten[elementInArray.speiseplan_rezepte_id] ? komponenten[elementInArray.speiseplan_rezepte_id] : "0"}
            ok-text="speichern"
            cancel-text="abbrechen"
          >
            <IonSelectOption key="val0" value="0">
              0
            </IonSelectOption>
            <IonSelectOption key="val2" value="2">
              2
            </IonSelectOption>
            <IonSelectOption key="val_175" value="1.75">
              1 3/4
            </IonSelectOption>
            <IonSelectOption key="val1_5" value="1.5">
              1 1/2
            </IonSelectOption>
            <IonSelectOption key="val1_25" value="1.25">
              1 1/4
            </IonSelectOption>
            <IonSelectOption key="val1" value="1">
              1
            </IonSelectOption>
            <IonSelectOption key="val0_75" value="0.75">
              3/4
            </IonSelectOption>
            <IonSelectOption key="val0_5" value="0.5">
              1/2
            </IonSelectOption>
            <IonSelectOption key="val0_25" value="0.25">
              1/4
            </IonSelectOption>
          </IonSelect>
        </IonItem>
      </IonItem>
    );
  }

  function BewohnerWahlErzeugen() {
    return (
      <IonRow>
        <IonCol>
          {appBewohnerIndex === 0 ? (
            ""
          ) : (
            <IonButton
              float-left
              routerLink={PrevBewohnerLink}
              onClick={() => {
                appBewohnerIdChange(PrevBewohnerId);
                setBewindex(appBewohnerIndex - 1);
                appBewohnerIndexChange(appBewohnerIndex - 1);
              }}
            >
              zurück
            </IonButton>
          )}
        </IonCol>
        <IonCol>{bewohnerbezeichnung}</IonCol>
        <IonCol>
          <IonButton
            float-right
            routerLink={NextBewohnerLink}
            onClick={() => {
              appBewohnerIdChange(NextBewohnerId);
              setBewindex(appBewohnerIndex + 1);
              appBewohnerIndexChange(appBewohnerIndex + 1);
            }}
          >
            weiter
          </IonButton>
        </IonCol>
      </IonRow>
    );
  }

  function addKomponente(rezept: any, my_element: any) {
    let alt_komponenten = komponenten;
    alt_komponenten[rezept] = my_element.value;
    setKomponenten(alt_komponenten);
    setSpeiseplanreturn(speiseplan());
    if( 0 > 1 ) send_data(appServer, appToken, bewohnerid, rezept, my_element.value, zeit, datumPicker);
  }

  useEffect(() => {
    let alt_komponenten = komponenten;
    gewaehlt &&
      gewaehlt.map((gewaehltInArray: any) => {
        if (gewaehltInArray.bewohner_verzehr_zeit === zeit) {
          alt_komponenten[gewaehltInArray.rezepte_id] = gewaehltInArray.bewohner_verzehr_menge;
        }
      });
    setKomponenten(alt_komponenten);

    setSpeiseplanreturn(speiseplan());
  }, [gewaehlt]);

  useEffect(() => {
    checkAuswahl();
    checkGewaehlt();
    let datumPicker_unixtime = new Date(datumPicker).valueOf();
    let day_span_unixtime = 1000 * 60 * 60 * 24;
    setDatumPickerPrev(new Date(datumPicker_unixtime - day_span_unixtime ).toISOString().split('T')[0]);
    setDatumPickerNext(new Date(datumPicker_unixtime + day_span_unixtime ).toISOString().split('T')[0]);
  }, [zeit, datumPicker]);

  useEffect(() => {
    //setSpeiseplanreturn(speiseplan())
  }, [auswahl]);

  useEffect(() => {
    let bmi = Math.round(gewicht / ((groesse / 100) * (groesse / 100)));
    setBMI(bmi);
    if (bmi < 19) {
      setBMIFarbe("warning");
    } else if (bmi >= 19 && bmi <= 25) {
      setBMIFarbe("success");
    } else {
      setBMIFarbe("warning");
    }
  }, [groesse, gewicht]);

  useIonViewDidEnter(() => {
    const checkBewohner = async () => {
      const { value } = await Preferences.get({ key: "senioren.bewohner" });
      if( value ) {
        JSON.parse(value).map((elementInArray: any, index: number) => {
          //prev_name=elementInArray.bewohnerbezeichnung;
          if (elementInArray.betriebe_bewohner_id == appBewohnerId) {
            setBewindex(index);
            appBewohnerIndexChange(index);

            setGewicht(elementInArray.betriebe_bewohner_gewicht);
            setGroesse(elementInArray.betriebe_bewohner_groesse);
          }
        });
      }
    };
    checkBewohner();
  });

  useEffect(() => {
    var newNextBewohnerLink = "";
    var newPrevBewohnerLink = "";
    var newNextBewohnerId = 0;
    var newPrevBewohnerId = 0;
    const checkBewohnerNext = async () => {
      const { value } = await Preferences.get({ key: "senioren.bewohner" });
      if( value ) {
        JSON.parse(value).map((elementInArray: any, index: any) => {
          //prev_name=elementInArray.bewohnerbezeichnung;
          if (index === bewindex - 1) {
            newPrevBewohnerLink =
              "/tag/" +
              zeit +
              "/" +
              datum +
              "/" +
              elementInArray.betriebe_bewohner_id +
              "/" +
              elementInArray.betriebe_bewohner_nachname +
              "_" +
              elementInArray.betriebe_bewohner_vorname;
            newPrevBewohnerId = elementInArray.betriebe_bewohner_id;
          }
          if (index === bewindex + 1) {
            newNextBewohnerLink =
              "/tag/" +
              zeit +
              "/" +
              datum +
              "/" +
              elementInArray.betriebe_bewohner_id +
              "/" +
              elementInArray.betriebe_bewohner_nachname +
              "_" +
              elementInArray.betriebe_bewohner_vorname;
            newNextBewohnerId = elementInArray.betriebe_bewohner_id;
          }
        });
      }
      setNextBewohnerLink(newNextBewohnerLink);
      setPrevBewohnerLink(newPrevBewohnerLink);
      setNextBewohnerId(newNextBewohnerId);
      setPrevBewohnerId(newPrevBewohnerId);
    };
    checkBewohnerNext().then( () => setBewohnerWahlReturn(BewohnerWahlErzeugen()));
  }, [bewindex]);

  /* useEffect(
    () =>
      {

        checkGewaehlt()
      } ,
    [ bewohnerid ]
  )  */

  return (
    <IonPage>
      { mk_ion_header( bewohnerbezeichnung ) }
      <IonContent fullscreen>
        { mk_ion_header( bewohnerbezeichnung , 'large' ) }
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonButton float-left onClick={() => setDatumPicker(datumPickerPrev)}>
                zurück
              </IonButton>
            </IonCol>
            <IonCol>
              <IonItem>
                <IonInput value={datumPicker} id="date"></IonInput>
                <IonPopover trigger="date" size="cover">
                  <IonDatetime presentation="date" locale="de-De" value={datumPicker} onIonChange={(e) => setDatumPicker(e.target.value)}></IonDatetime>
                </IonPopover>
              </IonItem>
            </IonCol>
            <IonCol>
              <IonButton float-right onClick={() => setDatumPicker(datumPickerNext)}>
                weiter
              </IonButton>
            </IonCol>
          </IonRow>
          {BewohnerWahlReturn && BewohnerWahlReturn}
        </IonGrid>
        <IonSegment value={zeit} onClick={(e) => { let my_el: any = e.target ; setZeit(my_el.value) ; } }>
          <IonSegmentButton value="1">
            <IonLabel>Frühstück</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="2">
            <IonLabel>Mittag</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="3">
            <IonLabel>Abend</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonLabel>Gewicht</IonLabel>
              <IonInput value={gewicht} onIonChange={(e) => setGewicht(e.target.value)}></IonInput>
            </IonCol>
            <IonCol>
              <IonLabel>Größe in cm</IonLabel>
              <IonInput value={groesse} onIonChange={(e) => setGroesse(e.target.value)}></IonInput>
            </IonCol>
            <IonCol>
              <IonLabel color={bmifarbe}>BMI</IonLabel>
              <IonInput color={bmifarbe} disabled value={bmi}></IonInput>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonList>{speiseplanreturn && speiseplanreturn}</IonList>
      </IonContent>
    </IonPage>
  );
}
